import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { ModalService } from '@spartacus/storefront';
import { Observable } from 'rxjs';

@Component({
  selector: 'sd-time-slot-datepicker-modal',
  templateUrl: './time-slot-datepicker-modal.component.html',
  styleUrls: ['./time-slot-datepicker-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SdvorTimeSlotDatepickerModalComponent {
  minDate$: Observable<NgbDateStruct>;
  maxDate$: Observable<NgbDateStruct>;
  markDisabled: (date: NgbDateStruct) => boolean;

  constructor(private modalService: ModalService) {}

  onSelectAnotherDateNgb(e: NgbDateStruct): void {
    this.modalService.closeActiveModal(e);
  }
}
